import React from 'react';
import { useIsMutating } from 'react-query';
import { StickyFooter } from '../../../../../CommonComponents/OPL/StickyFooter/StickyFooter';
import { Button } from '../../../../../CommonComponents/OPL/Button/Button';
import { useCharitableGivingContext } from '../../context/useCharitableGivingContext';
import { useRouteParams } from '../../../../hooks/useRouteParams';
import { SAVE_CHARITABLE_GIVING_WORKFLOW_MK } from '../../api/useCharitableGivingMutation';

interface StepFooterProps {
  isFirstStep?: boolean;
  progress: number;
  onPrevious?(): void;
  isLoading?: boolean;
}

export const StepFooter = ({ isFirstStep, progress, onPrevious, isLoading }: StepFooterProps) => {
  const { steps, step, setStep, onPreviousStage } = useCharitableGivingContext();

  const { clientId, goalId } = useRouteParams();

  const isSavingWorkflow = useIsMutating({ mutationKey: SAVE_CHARITABLE_GIVING_WORKFLOW_MK }) > 0;

  return (
    <StickyFooter progress={progress} progressVariant={progress === 100 ? 'success' : undefined}>
      {isFirstStep && (
        <Button
          variant="secondary"
          size="large"
          onClick={onPreviousStage}
          leftIcon="fas fa-chevron-left"
          mr="auto"
        >
          Personal Info
        </Button>
      )}

      {!isFirstStep && step !== 'review' && onPrevious && (
        <Button
          variant="secondary"
          size="large"
          onClick={onPrevious}
          leftIcon="fas fa-chevron-left"
          mr="auto"
        >
          Previous
        </Button>
      )}

      {step === 'review' && (
        <Button
          variant="secondary"
          size="large"
          onClick={() => setStep(steps[0])}
          leftIcon="far fa-pencil"
          mr="auto"
        >
          Edit
        </Button>
      )}

      <Button
        size="large"
        variant="subtleInactive"
        onClick={() => {
          if (goalId && step !== 'review') {
            setStep('review');

            return;
          }

          ADV.util.Router.go2('CharitableGivingWorkflowGoals', {
            clientId,
          });
        }}
      >
        Cancel
      </Button>

      {step === 'review' ? (
        <Button type="submit" size="large" ml="16" isLoading={isSavingWorkflow}>
          {goalId ? 'Save' : 'Take Me to My Plan'}
        </Button>
      ) : (
        <Button
          type="submit"
          size="large"
          rightIcon="fas fa-chevron-right"
          isLoading={isLoading}
          ml="16"
        >
          Next
        </Button>
      )}
    </StickyFooter>
  );
};
